<template>
    <div class="tab-pane active">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Name') }}</th>
                    <th>{{ $t('Prices') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(service, i) in services" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ service.name[locale] }}</td>
                    <td>{{ service.condition.price }} {{ service.condition.price_1st_hr ? service.condition.price_1st_hr+'/' : '' }}{{ service.condition.price_2nd_hr }}</td>
                    <td class="p-0">
                        <div class="text-right">
                            <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_service', {service})" small>
                                {{ $t('Edit') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <update-modal @setService="setService"/>
    </div>
</template>

<script>
import PaidServiceService from '@services/paidService.service';
import {mapGetters} from 'vuex';
import UpdateModal from '@views/Admin/Settings/tabs/Services/modals/Update.vue';

export default {
    data() {
        return {
            services: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getServices() {
            PaidServiceService.services().then(res => this.services = res);
        },
        setService() {
            this.getServices();
        }
    },
    components: {
        UpdateModal
    },
    created() {
        this.getServices();
    },
    metaInfo() {
        return {
            title: this.$t('Services')
        };
    }
};
</script>
